/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationSalesUpdate
 */
export interface OrganizationSalesUpdate {
    /**
     * 
     * @type {string}
     * @memberof OrganizationSalesUpdate
     */
    org_code: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationSalesUpdate
     */
    features?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSalesUpdate
     */
    is_safeguard_organization: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSalesUpdate
     */
    subscription_start_timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSalesUpdate
     */
    trial_end_timestamp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSalesUpdate
     */
    subscription_duration: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSalesUpdate
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the OrganizationSalesUpdate interface.
 */
export function instanceOfOrganizationSalesUpdate(value: object): value is OrganizationSalesUpdate {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('is_safeguard_organization' in value) || value['is_safeguard_organization'] === undefined) return false;
    if (!('subscription_start_timestamp' in value) || value['subscription_start_timestamp'] === undefined) return false;
    if (!('subscription_duration' in value) || value['subscription_duration'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function OrganizationSalesUpdateFromJSON(json: any): OrganizationSalesUpdate {
    return OrganizationSalesUpdateFromJSONTyped(json, false);
}

export function OrganizationSalesUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationSalesUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'features': json['features'] == null ? undefined : json['features'],
        'is_safeguard_organization': json['is_safeguard_organization'],
        'subscription_start_timestamp': json['subscription_start_timestamp'],
        'trial_end_timestamp': json['trial_end_timestamp'] == null ? undefined : json['trial_end_timestamp'],
        'subscription_duration': json['subscription_duration'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function OrganizationSalesUpdateToJSON(json: any): OrganizationSalesUpdate {
    return OrganizationSalesUpdateToJSONTyped(json, false);
}

export function OrganizationSalesUpdateToJSONTyped(value?: OrganizationSalesUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'features': value['features'],
        'is_safeguard_organization': value['is_safeguard_organization'],
        'subscription_start_timestamp': value['subscription_start_timestamp'],
        'trial_end_timestamp': value['trial_end_timestamp'],
        'subscription_duration': value['subscription_duration'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

